export { default as Hero } from "./hero"
export { default as AboutCentury } from "./about-century"
export { default as AboutCenturyIndonesia } from "./about-century-indonesia"